import { Box, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'

import ToothIcon from '@/assets/images/fi-rs-tooth.png'
import Chip from '@/components/Chip'
import PieChart from '@/components/PieChart'
import { useBreakpoints } from '@/hooks/useBreakpoints'
import { isNullorEmpty } from '@/utils'
import { pieChartSections } from '@/utils/constants'
import { analogRecipeChart } from '@/utils/matisseV2/analog'

type DentinRecipeProps = { recipeOutput: any; brand: string }

const PieChartCard = ({
  title,
  labels,
  values,
}: {
  title: string
  labels?: string[]
  values?: number[]
}) => {
  return (
    <Box
      sx={{
        minHeight: 350,
        height: '100%',
        flexGrow: 1,
        // minWidth: '225px',
        maxWidth: '300px',
        width: '31%',
        background: `linear-gradient(
          133.84deg,
          #4e4e4e -16.04%,
          #333333 9.33%,
          #1a1a1a 32.02%,
          #1a1a1a 62.06%,
          #262626 87.42%,
          #4e4e4e 112.12%
        )`,
        padding: 3,
        borderRadius: '16px',
        '@media (max-width: 1094px)': { minWidth: '350px' },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        mb={3}
        gap={1}
      >
        <img src={ToothIcon} alt="error" />
        <Typography fontSize={'24px'} fontWeight={'bolder'} lineHeight={'20px'}>
          {title}
        </Typography>
      </Box>
      <Box
        flexGrow={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <PieChart labels={labels} values={values} />
      </Box>
    </Box>
  )
}

const DentinRecipe = ({ recipeOutput, brand }: DentinRecipeProps) => {
  const theme = useTheme()
  const isSingleDentin =
    recipeOutput?.provided_input?.recipe_type === 'single dentin'

  const updatedList = pieChartSections?.filter((item) =>
    isSingleDentin ? item?.key === 'middle' : item,
  )

  const { isDisplay1300 } = useBreakpoints()

  return (
    <Box
      display="flex"
      flexDirection="column"
      px="32px"
      gap="16px"
      height="100%"
      sx={{ color: 'white' }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Typography
          sx={{ fontSize: '1.25rem', fontWeight: 500, lineHeight: '20px' }}
        >
          Dentin:
        </Typography>
        {isNullorEmpty(brand) && (
          <Chip
            label={brand}
            sx={{
              bgcolor: theme.palette.background.chip,

              color: theme.palette.common.black,
              '&:hover': { bgcolor: theme.palette.background.chip },
            }}
          />
        )}
      </Box>

      <Stack
        direction="row"
        spacing={5}
        width="100%"
        sx={{
          justifyContent: 'center',
          ...(isDisplay1300
            ? { gap: '0', flexWrap: 'nowrap' }
            : { gap: '32px', flexWrap: 'wrap' }),
        }}
      >
        {updatedList?.map(({ key, label }) => {
          const chart = analogRecipeChart(
            recipeOutput?.[`ceramic_recipe_${key}`],
          )
          return (
            <React.Fragment key={key}>
              <PieChartCard
                key={key}
                title={label}
                labels={chart.labels}
                values={chart.values as number[]}
              />
            </React.Fragment>
          )
        })}
      </Stack>
    </Box>
  )
}

export default DentinRecipe
